import styles from "./PopUpText.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { library } from '@fortawesome/fontawesome-svg-core'
library.add(fal);

function PopUpText({ bodyText, hasHeader, hasIcon, className, ...props }) {
  let iconComponent = hasIcon ? (
    <FontAwesomeIcon
      className={styles.icon}
      icon={["fal", "circle-info"]}
    />
  ) : (
    null
  );

  return (
    <div
      className={[styles.container, className, hasHeader && styles.hasHeader]
        .filter((e) => !!e)
        .join(" ")} {...props}
    >
      {iconComponent}
      <p className={styles.bodyContent}>{bodyText}</p>
    </div>
  );
}

export default PopUpText;
